<ng-container *ngIf="bonusPointsState$ | async as bonusPoints">
  <div class="amadeus-direct-style">
    <ng-container *ngIf="bonusPoints.isLoading">
      <spinner fixed="true"></spinner>
    </ng-container>

    <ng-container *ngIf="!bonusPoints.isLoading">
      <div class="loyalty-wrap business-wrap">
        <div *ngIf="!isSnow" class="amadeus-direct-style">
          <div class="row">
            <img
              class="img-fluid col-lg-12 mx-0 px-0 g-0"
              alt="Responsive banner"
              src="/assets/images/banner/plusme-banner.png"
            />
          </div>
        </div>

        <div class="container pt-lg-9 px-lg-10 pt-md-9 px-md-10">
          <div class="row px-lg-10 px-md-10">
            <div class="col-lg-12">
              <div
                data-id="points-balance"
                class="business-content loyalty-page-container"
                *ngIf="!bonusPoints.loadingError; else loadingError"
              >
                <h1 i18n="@@loyalty-bonus-points.loyaltyInnerPagePointsBalance">Points Balance</h1>
                <h4 class="points-subtitle">
                  {{ loyaltyInnerPageFindPointsStatusString }}: {{ bonusPoints.data.number }}
                </h4>
                <ng-container *ngIf="!bonusPoints.isLoading && bonusPoints.code !== 200">
                  <div class="row">
                    <div class="col-12 col-sm-12">
                      <p class="pink_error">{{ loyaltyErrorInformationNotAvaiableString }}</p>
                      <br />
                    </div>
                  </div>
                </ng-container>
                <ngb-alert
                  *ngIf="
                    enablePointBalanceBannerTile &&
                    expirationPointsEnabledForMarket &&
                    bonusPoints?.data?.toBeExpired !== null
                  "
                  class="my-5"
                  dfInsertAlertIcon
                  [dismissible]="false"
                >
                  <strong *ngIf="bonusPoints?.data?.toBeExpired !== -9999; else noAccumulation" class="pe-6">
                    {{ youHaveConstantString }} {{ (bonusPoints.data.toBeExpired | number) || 0 }}
                    {{ pointsExpiryString }} {{ lastDayOfMonth | reefDate: 'yyyy/MM/dd' }}
                    {{ gmtConstantString }}</strong
                  >
                  <ng-template #noAccumulation>
                    <strong class="pe-6"
                      >{{ expiringConstantString }} {{ lastDayOfMonth | reefDate: 'yyyy/MM/dd' }}
                      {{ gmtConstantString }} : {{ cronGenericFailureString }}</strong
                    >
                  </ng-template>
                </ngb-alert>
                <div class="row">
                  <div class="col-12 col-sm-4">
                    <div class="loyalty-table-container">
                      <table>
                        <thead>
                          <tr>
                            <td>
                              <div class="table-title" i18n="loyalty-bonus-points.accountFirstPointsBalance">
                                Points Balance
                              </div>
                            </td>
                            <td></td>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td i18n="loyalty-bonus-points.accountFirstAccumulatedPoints">Accumulated</td>
                            <td>
                              {{ bonusPoints.data.accumulated | number }}
                              <span
                                class="fa-circle-info df-rond-icon-only-focusable fa-solid ms-2 text-secondary"
                                tabindex="0"
                                placement="top auto"
                                [ngbTooltip]="htmlContentAccumulated"
                              ></span>
                            </td>
                          </tr>
                          <tr>
                            <td i18n="loyalty-bonus-points.accountFirstUsedPoints">Used</td>
                            <td>
                              {{ bonusPoints.data.used | number }}
                              <span
                                class="fa-circle-info df-rond-icon-only-focusable fa-solid ms-2 text-secondary"
                                tabindex="0"
                                placement="top auto"
                                [ngbTooltip]="htmlContentUsed"
                              ></span>
                            </td>
                          </tr>
                          <tr>
                            <td i18n="loyalty-bonus-points.accountFirstExpiredPoints">Expired</td>
                            <td>
                              {{ bonusPoints.data.expired ? (bonusPoints.data.expired | number) : 0 }}
                              <span
                                class="fa-circle-info df-rond-icon-only-focusable fa-solid ms-2 text-secondary"
                                tabindex="0"
                                placement="top auto"
                                [ngbTooltip]="htmlContentExpired"
                              ></span>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <strong i18n="loyalty-bonus-points.accountFirstAvailablePoints">Available</strong>
                            </td>
                            <td>
                              <strong> {{ bonusPoints.data.available | number }} </strong>
                              <span
                                class="fa-circle-info df-rond-icon-only-focusable fa-solid ms-2 text-secondary"
                                tabindex="0"
                                placement="top auto"
                                [ngbTooltip]="htmlContentAvailable"
                              ></span>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <div class="col-12 col-sm-4">
                    <div class="loyalty-table-container">
                      <table>
                        <thead>
                          <tr>
                            <td>
                              <div class="table-title">{{ accountFirstSegmentsString }}</div>
                            </td>
                            <td></td>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td i18n="@@loyalty-bonus-points.accountFirstPending">Pending</td>
                            <td>
                              {{ bonusPoints.data.totalSegmentsPD | number }}
                              <span
                                class="fa-circle-info df-rond-icon-only-focusable fa-solid ms-2 text-secondary"
                                tabindex="0"
                                placement="top auto"
                                [ngbTooltip]="htmlContentPending"
                              ></span>
                            </td>
                          </tr>
                          <tr>
                            <td i18n="@@loyalty-bonus-points.accountFirstValidated">Validated</td>
                            <td>
                              {{ bonusPoints.data.totalSegmentsOk | number }}
                              <span
                                class="fa-circle-info df-rond-icon-only-focusable fa-solid ms-2 text-secondary"
                                tabindex="0"
                                placement="top auto"
                                [ngbTooltip]="htmlContentValidated"
                              ></span>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <strong i18n="loyalty-bonus-points.accountFirstTotal">Total</strong>
                            </td>
                            <td>
                              <strong>{{ bonusPoints.data.totalSegments | number }}</strong>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <div class="col-12 col-sm-4">
                    <div class="loyalty-table-container">
                      <table>
                        <thead>
                          <tr>
                            <td>
                              <div class="table-title" i18n="loyalty-bonus-points.accountFirstPoints">Points</div>
                            </td>
                            <td></td>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td i18n="loyalty-bonus-points.accountFirstRegular">Regular</td>
                            <td>
                              {{ bonusPoints.data.regular | number }}
                              <span
                                class="fa-circle-info df-rond-icon-only-focusable fa-solid ms-2 text-secondary"
                                tabindex="0"
                                placement="top auto"
                                [ngbTooltip]="htmlContentRegular"
                              ></span>
                            </td>
                          </tr>
                          <tr>
                            <td i18n="loyalty-bonus-points.accountFirstAdditional">Additional</td>
                            <td>
                              {{ bonusPoints.data.additional | number }}
                              <span
                                class="fa-circle-info df-rond-icon-only-focusable fa-solid ms-2 text-secondary"
                                tabindex="0"
                                placement="top auto"
                                [ngbTooltip]="htmlContentAdditional"
                              ></span>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
               <div class="gift-catalog">
                <button class="btn interactive" 
                (click)="redirectToOrderGifts()" 
                type="button">
                {{giftCatalogTitle}}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div> 
    </ng-container>
  </div>
  <ng-template #loadingError>
    <loading-error [message]="bonusPoints.loadingError"></loading-error>
  </ng-template>
</ng-container>

<ng-template #htmlContentPending>
  <div i18n="loyalty-bonus-points.accountFirstTooltipPending">Pending segments before departure</div>
</ng-template>

<ng-template #htmlContentValidated>
  <div i18n="loyalty-bonus-points.accountFirstTooltipValidated">Validated segments will be credited with points</div>
</ng-template>

<ng-template #htmlContentAccumulated>
  <div i18n="loyalty-bonus-points.accountFirstTooltipAccumulated">The amount of total points gained</div>
</ng-template>

<ng-template #htmlContentUsed>
  <div i18n="loyalty-bonus-points.accountFirstTooltipUsed">Points redeemed for gift orders</div>
</ng-template>

<ng-template #htmlContentExpired>
  <div i18n="loyalty-bonus-points.accountFirstTooltipExpired">
    Credit points will expire three (3) years following the date they are credited to your Amadeus+Me account.
  </div>
</ng-template>

<ng-template #htmlContentAvailable>
  <div i18n="loyalty-bonus-points.accountFirstTooltipAvailable">
    The remaining available points that can be redeemed
  </div>
</ng-template>

<ng-template #htmlContentRegular>
  <div i18n="loyalty-bonus-points.accountFirstTooltipRegular">Total points accumulated</div>
</ng-template>

<ng-template #htmlContentAdditional>
  <div i18n="loyalty-bonus-points.accountFirstTooltipAdditional">Additional bonus points</div>
</ng-template>
